import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { OfferSection } from '../components/OfferSection';
import { CloseSection } from '../components/CloseSection';
import { Footer } from '../components/Footer';
import { FractalBackground } from '../components/FractalBackground';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#050a0f] text-[#c8c0b0] selection:bg-[#00d4ff] selection:text-[#050a0f]" data-id="element-238">
      {/* Fractal Network Background */}
      <FractalBackground data-id="element-239" />

      {/* Global Scanline Overlay */}
      <div className="scanline-overlay" data-id="element-240" />

      {/* Content — solid bg ensures sections are always visible even if canvas pauses */}
      <div className="relative" style={{
      zIndex: 1
    }} data-id="element-241">
        <HeroSection data-id="element-242" />
        <ProblemSection data-id="element-243" />
        <MechanismSection data-id="element-244" />
        <OfferSection data-id="element-245" />
        <CloseSection data-id="element-246" />
        <Footer data-id="element-247" />
      </div>
    </main>;
}